import React, {useEffect, useState} from 'react';
import {SearchOutlined} from "@ant-design/icons";
import {onChangeVisibleModal} from "../../../redux/actions/layout/interaction/action";
import {useSearchParams} from "react-router-dom";
import {t} from "i18next";

function SearchEmpty({searchValue}) {
    const [searchParams] = useSearchParams();
    const [content,setContent ] = useState({
        title: t("common.empty.record"),
        message: t("common.empty.record")
    })
    useEffect(() => {
        switch (window.location.pathname) {
            case "/hrm/timekeeping/time-sheet/timesheet" :
                if(searchParams.get("view-shift-work")){
                    setContent({
                        title :  t("common.empty.shiftWork"),
                        message :  t("common.empty.shiftWork"),
                    }) ;
                    break ;
                }
                else {
                    setContent({
                        title :  t("common.empty.timekeeping"),
                        message :  t("common.empty.timekeeping"),
                    }) ;
                    break ;
                }

            case "/hrm/timekeeping/time-sheet/shift-assignment" :
                setContent({
                    title :  t("common.empty.shiftAssignment"),
                    message :  t("common.empty.shiftAssignment"),
                }) ;
                break ;

            case "/hrm/timekeeping/time-sheet/auto-check-in-out" :
                setContent({
                    title :  t("common.empty.autoTimeKeeping"),
                    message :  t("common.empty.autoTimeKeeping"),
                }) ;
                break ;
            case "/hrm/timekeeping/casual-and-compensatory/casual-leave" :
                setContent({
                    title :  t("common.empty.leave"),
                    message :  t("common.empty.leave"),
                }) ;
                break ;
            case "/hrm/timekeeping/wage/table" :
                setContent({
                    title :  t("common.empty.payroll"),
                    message :  t("common.empty.payroll"),
                }) ;
                break ;
            case "/hrm/timekeeping/wage/template" :
                setContent({
                    title :  t("common.empty.payrollConfig"),
                    message :  t("common.empty.payrollConfig"),
                }) ;
                break ;

            case "/setting/timekeeping/shift-work" :
                setContent({
                    title :  t("common.empty.shiftConfig"),
                    message :  t("common.empty.shiftConfig"),
                }) ;
                break ;
            case "/setting/timekeeping/annual-leave" :
                setContent({
                    title :  t("common.empty.leaveConfig"),
                    message :  t("common.empty.leaveConfig"),
                }) ;
                break ;
            case "/setting/timekeeping/attendance-locations" :
                setContent({
                    title :  t("common.empty.locationCheckIn"),
                    message :  t("common.empty.locationCheckIn"),
                }) ;
                break ;
        }
    }, [window.location.pathname]);

    return (
        <div
            className={`bg-white rounded-bl-[12px] rounded-br-[12px] overflow-hidden h-[92%] flex justify-center`}
            style={{
                borderRight: "1px solid #EAECF0",
                borderLeft: "1px solid #EAECF0",
                borderBottom: "1px solid #EAECF0",
            }}
        >
            <div className={'text-center text-[var(--primary-text-color)] mt-40'}>
                <div className={'width-full flex justify-center'}>
                    <div style={{
                        height: '40px',
                        width: '40px',
                        borderRadius: '50%',
                        marginBottom: '10px',
                        backgroundColor:'#e1e1e4',
                        fontSize: '24px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        outline: '6px solid #efefef',
                        color: '#88898a'
                    }}>
                        <SearchOutlined />
                    </div>
                </div>
                <p className={'font-bold leading-7 text-lg'}>{t("tnp.components.objectAssign.notFound")} {content.title} </p>
                <p className={'leading-7 text-sm'}>{`"${searchValue}" ${t("common.empty.searchEmpty",{ title : content.message})}`}</p>
                <p className={'leading-4 text-sm'}>{t("tnp.components.objectAssign.tryAgain")}.</p>
            </div>
        </div>
    );
}

export default SearchEmpty;